import React from 'react'
import { useParams } from 'react-router-dom'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuWriteOff from '../submenu/SubmenuWriteOff'
import WriteOffActView from './view/WriteOffActView'

const WriteOffAct = () => {

    const { writeOffActId } = useParams()

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuWriteOff />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Акт на списання № ' + writeOffActId}
            isBack={true}
            // options={
            //     <SupplyOrderOptions />
            // }
        />
		<MyBlock>
			<WriteOffActView
				writeOffActId={writeOffActId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default WriteOffAct